import { Media } from '@/components/Media'
import { Button, Card, Pill, Stack, Text } from '@/design-system'
import { BentoGrid, BentoSpan } from '@/components/Bento'
import { PageHeader } from '@/app/layouts/PageHeader'
import checkout from '@/app/layouts/CheckoutLayout.module.css'
import { BRAND } from '@/brand/brand'

import { Link } from 'react-router'
import { FLIGHTS } from './travel-data'

export function FlightsScreen() {
  return (
    <>
      <PageHeader
        title="Flights"
        subtitle="The routes home, with the fare alert already set on your corridor."
        actions={<Button variant="ghost" size="md" iconStart="notifications_active">Fare alerts</Button>}
      />

      <BentoGrid>
        <BentoSpan span={3}>
          <Card tone="light">
            <Card.Header>
              <Text variant="caption" weight="semibold">Your corridors</Text>
              <Text variant="eyebrow" tone="secondary">One way · next 60 days</Text>
            </Card.Header>
            <Stack gap={0} className="pb-mt-3">
              {FLIGHTS.map((flight) => (
                <Link key={flight.slug} to={`/travel/flights/${flight.slug}`} className={checkout.line} style={{ width: '100%' }}>
                  <Media src={flight.image} alt="" width={64} ratio={1} radius="md" icon="flight_takeoff" />
                  <Stack grow gap={0} align="start">
                    <Text variant="caption" weight="semibold">{flight.route}</Text>
                    <Text variant="caption" tone="secondary" truncate>{flight.airline} · {flight.time}</Text>
                  </Stack>
                  <Stack align="end" gap={0} style={{ width: '6rem' }}>
                    <Text variant="caption" weight="semibold" numeric>{flight.price}</Text>
                    <Text variant="eyebrow" weight="bold" tone="positive" numeric>+{flight.back} back</Text>
                  </Stack>
                </Link>
              ))}
            </Stack>
          </Card>
        </BentoSpan>

        <Card tone="dark">
          <Card.Header>
            <Text variant="caption" weight="semibold" tone="onDark">Pay in 4</Text>
            <Pill tone="accent">0% interest</Pill>
          </Card.Header>
          <Text variant="caption" tone="onDarkMuted" className="pb-mt-3">
            Split any fare over four payments, taken from your {BRAND.name} balance. The first one goes
            today, the rest every two weeks.
          </Text>
          <Stack gap={0} className="pb-mt-4">
            {[['Fare', '$578.16'], ['Four payments of', '$144.54'], ['Interest', 'None']].map(([label, value]) => (
              <div key={label} className={checkout.line}>
                <Text variant="caption" tone="onDarkMuted">{label}</Text>
                <Text variant="caption" weight="semibold" tone="onDark" numeric>{value}</Text>
              </div>
            ))}
          </Stack>
          <Card.Footer>
            <Button size="md" block iconEnd="arrow_forward" to={`/travel/flights/${FLIGHTS[0]?.slug ?? ''}`}>See how it works</Button>
          </Card.Footer>
        </Card>
      </BentoGrid>
    </>
  )
}
